import { render, staticRenderFns } from "./xmsbxq.vue?vue&type=template&id=a893e2ec&scoped=true&"
import script from "./xmsbxq.vue?vue&type=script&lang=js&"
export * from "./xmsbxq.vue?vue&type=script&lang=js&"
import style0 from "./xmsbxq.vue?vue&type=style&index=0&id=a893e2ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a893e2ec",
  null
  
)

export default component.exports